import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import translate from '../../lang';
import { vsprintf } from 'sprintf-js';

const TranslateComponent = ({
  lang,
  msg,
  msgArgs = null,
  component: Component = Fragment,
  dispatch,
  ...rest
}) => {
  const outputMsg = msgArgs ? vsprintf(translate(msg, lang), msgArgs) : translate(msg, lang);
  return <Component {...rest}>{outputMsg}</Component>;
};

TranslateComponent.propTypes = {
  msg: PropTypes.string.isRequired,
  lang: PropTypes.string.isRequired
};

const mapStateToProps = state => ({
  lang: state.lang
});

const TranslateWrapper = connect(mapStateToProps)(TranslateComponent);

// 添加静态方法用于在 JavaScript 代码中获取翻译文本
TranslateWrapper.renderMessage = (msg, args = [], lang = null) => {
  // 如果没有传入 lang，尝试从 localStorage 或默认值获取
  if (!lang) {
    lang = localStorage.getItem('lang') || 'zh_hk';
  }

  const translatedMsg = translate(msg, lang);

  // 如果有参数，使用 vsprintf 替换
  if (args && args.length > 0) {
    return vsprintf(translatedMsg, args);
  }

  return translatedMsg;
};

export default TranslateWrapper;
